@if (formattedDescription) {
  <div [class.multi-line]="isMultiLine">
    @switch (type) {
      @case ('PoolSale') {
        Sold from
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.sale"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
        for {{ data.price | aacurrency }}
        @if (hasTaxableUse) {
          ({{ data.taxableUse | aapercent }} Taxable Use)
        }
      }
      @case ('PoolWriteOff') {
        Disposed from
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.write-off"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
      }
      @case ('AddToPool') {
        Added to
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.add"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
        @if (formattedNotes) {
          <div [innerHTML]="formattedNotes | keepHtml"></div>
        }
      }
      @case ('TransferToPool') {
        Transferred to
        <a
          data-dd-action-name="transaction-description-cell-renderer.pool-link.transfer"
          [routerLink]="poolRoute(data)"
          >{{ data.poolName }}</a
        >
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
        @if (formattedNotes) {
          <div [innerHTML]="formattedNotes | keepHtml"></div>
        }
      }
      @case ('ComponentAdded') {
        Component added:
        <a
          data-dd-action-name="transaction-description-cell-renderer.component-link.added"
          [routerLink]="assetRoute(data, 'component')"
          >{{ assetName(data, 'component') }}</a
        >
      }
      @case ('ComponentRemoved') {
        Component removed:
        <a
          data-dd-action-name="transaction-description-cell-renderer.component-link.removed"
          [routerLink]="assetRoute(data, 'component')"
          >{{ assetName(data, 'component') }}</a
        >
      }
      @case ('ParentAdded') {
        Parent added:
        <a
          data-dd-action-name="transaction-description-cell-renderer.parent-link.added"
          [routerLink]="assetRoute(data, 'parent')"
          >{{ assetName(data, 'parent') }}</a
        >
      }
      @case ('ParentRemoved') {
        Parent removed:
        <a
          data-dd-action-name="transaction-description-cell-renderer.parent-link.removed"
          [routerLink]="assetRoute(data, 'parent')"
          >{{ assetName(data, 'parent') }}</a
        >
      }
      @case ('AssetGroupAssignedToAsset') {
        Group Assigned:
        <a
          data-dd-action-name="transaction-description-cell-renderer.asset-group-link"
          [routerLink]="assetGroupRoute(data)"
          >{{ assetGroupName(data) }}</a
        >
      }
      @default {
        <div [innerHTML]="formattedDescription | keepHtml"></div>
      }
    }
  </div>
}

@if (sourceText || importName) {
  <div class="source" [class.multi-line]="isMultiLine">
    {{ sourceText }}
    @if (importName) {
      <a
        data-dd-action-name="transaction-description-cell-renderer.import-source-link"
        [href]="sourceLink"
        >{{ importName }}</a
      >
    }
  </div>
}
